import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from 'react-i18next'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Input, Form } from 'components/Forms'
import { Alert } from 'ui'
import { closeModal } from 'store/actions/modals'

import { t } from 'translations'

const DeleteButtonModal = ({ children, requireConfirmation, onClick, title, row, archive, disableClose }) => {
  const dispatch = useDispatch()
  const { modalProps } = useSelector(state => state.modals)

  const onSubmit = async values => {
    await onClick(null, values)
    if (disableClose) return
    dispatch(closeModal())
  }

  return (
    <BaseModal destructive title={title} hideButtons={requireConfirmation} primaryAction={() => onSubmit(row)}>
      {typeof children === 'function' ? children(row, modalProps) : children}
      {requireConfirmation ? (
        <Formik
          enableReinitialize={true}
          initialValues={{ confirm: '' }}
          onSubmit={onSubmit}
          validationSchema={Yup.object().shape({
            confirm: Yup.string()
              .test(
                'CONFIRM',
                t(`administration.${archive ? 'ARCHIVE' : 'DELETE'}_BUTTON.BAD_MATCH`),
                value => value?.toLowerCase() === t(`actions.${archive ? 'ARCHIVE' : 'DELETE'}`).toLowerCase()
              )
              .required(`administration.${archive ? 'ARCHIVE' : 'DELETE'}_BUTTON.FIELD_IS_REQUIRED`)
          })}
        >
          {({ status, isSubmitting, setStatus, values }) => {
            return (
              <Form noPrompt>
                {/* Error message */}
                <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                  {status?.msg}
                </Alert>
                <div className="mb-3"></div>
                <Input module={archive ? 'administration.ARCHIVE_BUTTON' : 'administration.DELETE_BUTTON'} name="confirm" required />
                <Alert variant="danger">
                  <Trans t={t} i18nKey={'administration.confirmDeletion.WARNING'}>
                    <b></b>
                  </Trans>
                </Alert>
                <Button
                  className="btn btn-danger mr-2"
                  type="submit"
                  isSubmitting={isSubmitting}
                  text={`${title}.PRIMARY_ACTION`}
                  disabled={requireConfirmation ? values.confirm?.toLowerCase() !== t(`actions.${archive ? 'ARCHIVE' : 'DELETE'}`).toLowerCase() : null}
                />
                <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
                  {t(`actions.CLOSE`)}
                </Button>
              </Form>
            )
          }}
        </Formik>
      ) : null}
      <Alert variant="danger" className={'mt-2'} show={!requireConfirmation}>
        <Trans t={t} i18nKey={'administration.confirmDeletion.WARNING'}>
          <b></b>
        </Trans>
      </Alert>
    </BaseModal>
  )
}

export default DeleteButtonModal

DeleteButtonModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  disableClose: PropTypes.bool
}

DeleteButtonModal.defaultProps = {}
